import React from "react";
import { Route, Redirect } from "react-router-dom";
import { AuthContext } from "../../utils/userProvider";

const ProtectedRoute = ({ component: Component, ...rest }) => (
  <AuthContext.Consumer>
    {({ authState }) => {
      return (
        <Route
          render={(props) =>
            authState != null ? <Component {...props} /> : <Redirect to="/" />
          }
          {...rest}
        />
      );
    }}
  </AuthContext.Consumer>
);

export default ProtectedRoute;
